import type { LocaleMessages, Supervisor } from 'shared-types';

type SupervisorPermissions = Supervisor['permissions'];

interface Params {
  messages?: LocaleMessages;
}

// overloads
function getSupervisorPermissions(
  params: Params & { messages: LocaleMessages }
): Record<SupervisorPermissions[number], string>;
function getSupervisorPermissions(
  params: Params & { messages?: never }
): SupervisorPermissions;

// implementation
function getSupervisorPermissions({
  messages
}: Params):
  | Record<SupervisorPermissions[number], string>
  | SupervisorPermissions {
  if (messages) {
    return {
      'view-answers': messages.adminSupervisorPermissionsViewAnswers
    } satisfies Record<SupervisorPermissions[number], string>;
  }

  return ['view-answers'] as const satisfies SupervisorPermissions;
}

export default getSupervisorPermissions;
